import {DateTime} from "./models";

export default class MonthChoice {
    constructor(public d: DateTime) {}

    get value(): DateTime {
        return this.d;
    }
    get text(): string {
        return `${this.d.monthName()} ${this.d.year()}`;
    }
}
